import {
  drawPointsAnim,
  drawAngleAnim,
  drawLineAnim,
  drawCircleAnim,
  moveAllPointAnim,
  rotateCircleAnim,
} from "../../../../../../src/animation/Circle/helpers/drawHelpers";

import { ANGLE_NAME_FOR_ANIM, ARC_COLOR_ARR, INITIAL_RADIANS } from "../../types/Config";
import { normalizeRadian } from "../../../../../../src/utils/math/normalizeRadian";
import { ContextType } from "../../types/Interface";


export async function runCircleAnimation(context: ContextType, onComp: () => void) {
  const {
    circle,
    LineManager,
    PointManager,
    PointTagManager,
    AngleManager,
    cCoord,
  } = context;


  const centerPoint = PointManager.getPoints()[0];
  const pointsCoord = PointManager.getRedPointsCoord();
  const RedPoints = PointManager.getRedPoints();

  const initialRadian = PointManager.getInitialRadians();
  const radians = PointManager.getRadians();
  const angles = AngleManager.getAngles();

  AngleManager.draw(pointsCoord, [true, true], false);
  circle.setRadians([INITIAL_RADIANS[0], INITIAL_RADIANS[0]]);

  circle.setColors([0x000000, 0x000000, ARC_COLOR_ARR[2], 0x000000]);

  drawPointsAnim([centerPoint]);
  await drawCircleAnim(circle, INITIAL_RADIANS[0] + Math.PI * 2, 0, true, cCoord);

  await drawLineAnim(LineManager.lines[3], pointsCoord[0], pointsCoord[2]);
  await drawLineAnim(LineManager.lines[2], pointsCoord[2], pointsCoord[1]);
  await drawLineAnim(LineManager.lines[1], pointsCoord[1], pointsCoord[3]);
  await drawLineAnim(LineManager.lines[0], pointsCoord[3], pointsCoord[0]);

  circle.setRadians([INITIAL_RADIANS[0], INITIAL_RADIANS[1], INITIAL_RADIANS[2], INITIAL_RADIANS[2]]);
  await drawCircleAnim(circle, INITIAL_RADIANS[3], 3, false, cCoord);

  drawAngleAnim(angles[0], ANGLE_NAME_FOR_ANIM);
  await drawAngleAnim(angles[1], ANGLE_NAME_FOR_ANIM);

  PointTagManager.setAllVisible(true);

  await rotateCircleAnim((v) => {
    const arr = Array(4).fill(v).map((v, vI) => ({ pTag: RedPoints[vI].tag, radian: normalizeRadian(initialRadian[vI] + v) }));
    PointManager.setRadian(arr)
  });


  const pointAnimArr = [
    [-Math.PI / 1.5, -Math.PI / 3, -Math.PI / 8, -Math.PI / 1.1],
    [-Math.PI / 1.1, -Math.PI / 8, Math.PI / 7, Math.PI / 1.3],
    PointManager.getInitialRadians()
  ]

  for (let index = 0; index < pointAnimArr.length; index++) {
    const arr = pointAnimArr[index];
    await moveAllPointAnim(radians, arr, (radian, index) => PointManager.setRadian([{ pTag: RedPoints[index].tag, radian }]))
  }

  await drawPointsAnim(RedPoints);

  onComp();
}